import { Builder } from '@builder.io/react';
import OrangeHoverCards from './OrangeHoverCards';

Builder.registerComponent(OrangeHoverCards, {
  name: 'OrangeHoverCards',
  inputs: [
    {
      name: 'benefits',
      type: 'list',
      defaultValue: [{
        icon: '',
        title: 'Benefit title here',
        text: 'Benefit description here',
      }],
      copyOnAdd: true,
      subFields: [
        {
          name: 'icon',
          type: 'text',
          // enum: [
          //   'star',
          //   'house',
          //   'magic-wand-sparkles',
          //   'pencil',
          // ]
          helperText: 'The name of any free FontAwesome icon. Find them at: https://fontawesome.com/search?o=r&m=free'
        },
        {
          name: 'title',
          type: 'string',
        },
        {
          name: 'text',
          type: 'longText',
        },
      ],
    },
  ]
});
